import { AppRoute } from "app";
import { useAtomValue } from "jotai";
import { useNavigate } from "react-router-dom";

import Flex from "components/Flex";
import PhotoGrid from "components/PhotoGrid";
import { GridImage } from "components/PhotoGrid/types";
import Text from "components/Text";

import { sessionIdAtom } from "atoms/sessionId";
import { useEventTracking } from "hooks/useEventTracking";
import { replaceSessionInAppRoute } from "utils/routeHelper";

import { EditButton } from "../EditButton";

type PhotosSectionProps = {
  name: string;
  photos: GridImage[];
  editRoute: AppRoute;
};

export const PhotosSection = ({ name, photos, editRoute }: PhotosSectionProps) => {
  const sessionId = useAtomValue(sessionIdAtom);
  const navigate = useNavigate();
  const { trackEvent } = useEventTracking();

  const onEdit = () => {
    trackEvent({
      name: "Claim Summary - edit",
      properties: {
        pageName: name,
      },
    });

    navigate(replaceSessionInAppRoute(editRoute, sessionId), { state: "FROM_SUMMARY" });
  };

  return (
    <>
      <Flex as="section" direction="row" justify="space-between" mb={16}>
        <Text as="h2" sizeVariant="lg" weight={500}>
          {name}
        </Text>
        <EditButton onClick={onEdit} />
      </Flex>
      <PhotoGrid images={photos} />
    </>
  );
};
